import { useLayoutEffect, useState } from 'react';
import GutentagSearchWebsiteModal from './GutentagSearchWebsiteModal';
import { useModal } from '../../modal';
import { Button } from 'react-bootstrap';

export const GutentagSearchWebsite = () => {
    const modalController = useModal();
    const [showDefaultButton, setShowDefaultButton] = useState();

    const showSearchWebsiteModal = () => {
        modalController.show();
    }

    useLayoutEffect(() => {

        // Check if there is an element with the specific ID in DOM,
        // use it as the trigger instead of the default one.
        const searchDomainTriggerElement = document.getElementById('trigger-search-website');

        if (searchDomainTriggerElement) {
            searchDomainTriggerElement.addEventListener('click', showSearchWebsiteModal);
        }

        setShowDefaultButton(!searchDomainTriggerElement);

        return () => {
            if (searchDomainTriggerElement) {
                searchDomainTriggerElement.removeEventListener('click', showSearchWebsiteModal);
            }
        };

    }, []);

    return (
        <>
            <div className="text-center">
                {
                    showDefaultButton &&
                    <Button
                        className="btn-base btn bg-red-light rounded-pill text-white"
                        onClick={showSearchWebsiteModal}
                    >
                        Meine Fotografen finden
                    </Button>
                }
            </div>
            <GutentagSearchWebsiteModal controller={modalController}/>
        </>
    );
}
